module.exports = __webpack_public_path__ + "img/00-silo-shadow.013f2a92.png";